import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import config from '@/config';
import packageInfo from '../package.json';

const IGNORED_ERROR_PATTERNS = [
  /Script error\.?/i,
  /ResizeObserver loop limit exceeded/i,
  /ResizeObserver loop completed with undelivered notifications/i,
];

const isIgnoredError = (event, hint) => {
  const message = event && (
    event.message ||
    (event.exception &&
      event.exception.values &&
      event.exception.values[0] &&
      event.exception.values[0].value) ||
    (hint && hint.originalException && hint.originalException.message)
  );

  return message && IGNORED_ERROR_PATTERNS.some(pattern => pattern.test(message));
};

export const initSentry = () => {
  if (!config.sentryDsn) {
    return;
  }

  Sentry.init({
    Vue,
    dsn: config.sentryDsn,
    environment: process.env.NODE_ENV,
    release: `${packageInfo.name}@${packageInfo.version}`,
    sendDefaultPii: false,
    sampleRate: 1,
    beforeSend(event, hint) {
      if (isIgnoredError(event, hint)) {
        return null;
      }

      return event;
    },
  });
};

export default Sentry;
